import "./DCHeader.css";

type DCHeaderProps = {
    title: string;
    actions?: React.ReactNode[];
}
export const DCHeader = ({ title, actions }: DCHeaderProps) => {
    return (
        <div className="dc-header">
            {title}
            {actions && actions.map((action, index) => (
                <div key={index} className="dc-header-action">
                    {action}
                </div>
            ))}
        </div>
    );
}